<div class="component-wrapper">
    <ng-container *ngIf="showAnfrageInfo">
        <anfrage-info></anfrage-info>
        <app-info></app-info>
        <div style="overflow-y: auto; margin-bottom: 1rem;">
            <validation-summary></validation-summary>
        </div>
        <app-chat *ngIf="chatIsVisible" class="chat-component" [anfrageId]="anfrageId" [scope]="scope"></app-chat>
    </ng-container>
</div>
<div class="collapse-wrapper">
    <button (click)="onToggleClick()" tabindex="0">
        <span *ngIf="!showAnfrageInfo" class="arrow-left" [title]="'navigation.expand' | translate"></span>
        <span *ngIf="showAnfrageInfo" class="arrow-right" [title]="'navigation.collapse' | translate"></span>
    </button>
</div>
